<template>
  <div :class="{vote_detail_container:true,show_operate:detail.status==1 && detail.isBalloted==false}" v-if="!!detail">
    <div class="vote_detail_box" v-if="!!detail">
      <div :class="{detail_info:true,pdb2:detail.status != 0}">
        <img :src="detail.ballotImagePath" alt="" v-if="!!detail.ballotImagePath && detail.ballotImagePath.length > 0" />
        <img :src="require('@/assets/images/default_pic_16_9.png')" alt="" v-else />
        <div class="detail_info_box">
          <div class="title" v-text="detail.title"></div>
          <div class="vote_detail">
            <span class="vote_status ongoing" v-if="detail.status == 1">进行中</span>
            <span class="vote_status over" v-else-if="detail.status == 0">已结束</span>
            <span class="vote_status not_start" v-else>即将开始</span>
            <div class="vote_line">
              <div class="vote_item bd_right">
                <div class="detail_data" v-text="detail.count"></div>
                <div class="detail_label">累计投票</div>
              </div>
              <div class="vote_item">
                <div class="detail_data" v-text="detail.sum"></div>
                <div class="detail_label">参与人数</div>
              </div>
            </div>
            <!-- 投票进行中 -->
            <div class="vote_time_box" v-if="detail.status == 1">
              <div class="vote_time_label">投票结束倒计时：</div>
              <div class="vote_time_picker" v-html="timeStr"></div>
            </div>
            <!-- 投票结束 -->
            <div class="vote_time_box" v-else-if="detail.status==0">
              <div class="vote_time_label label_over">投票已结束</div>
            </div>
            <!-- 投票未开始 -->
            <div class="vote_time_box" v-else>
              <div class="vote_time_label">投票开始时间：</div>
              <div class="vote_time"><span v-text="detail.startDate"></span> <span v-text="detail.startTime"></span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="vote_list_box">
        <div class="vote_title" v-if="(detail.status==1 && detail.isBalloted==false)||detail.status==-1"><span v-text="detail.subtopicTitle"></span><span v-if="detail.multipleChoise">【多选】</span><span v-else>【单选】</span></div>
        <div class="vote_title" v-else-if="detail.status==1 && detail.isBalloted==true"><span>当前投票情况</span></div>
        <div class="vote_title" v-else><span>投票结果</span></div>
        <!-- 投票进行中、有图 -->
        <div class="vote_list clearfix" v-if="detail.status==1 && detail.imageChoise && detail.isBalloted==false">
          <div class="vote_item vote_item_img" v-for="(item,index) in detail.itemList" :key="index">
            <div :class="{checkbox:true,checked:item.isDefault}" v-if="detail.multipleChoise" @click="onCheckClick(item)">
              <div class="vote_img_box">
                <div class="img">
                  <img :src="item.imagePath" alt="" v-if="item.imagePath && item.imagePath.length>0">
                  <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                </div>
              </div>
              <input type="checkbox" :name="'checkboxGorup' + detail.id" :checked="item.isDefault">
              <div class="info">
                <span class="title_text" v-text="item.itemTitle"></span>
                <span class="vote">
                  <van-icon name="like-o" />{{item.amount}}票
                </span>
              </div>
              <span class="vote_btn" @click.stop="toItemDetail(item)" v-if="!!item.itemLinkUrl&&item.itemLinkUrl.length>0">查看详情</span>
            </div>
            <div :class="{radio:true,checked:item.isDefault}" v-else @click="onRadioClick(item)">
              <div class="vote_img_box">
                <div class="img">
                  <img :src="item.imagePath" alt="" v-if="item.imagePath && item.imagePath.length>0">
                  <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                </div>
              </div>
              <input type="radio" :name="'radioGorup' + detail.id" :checked="item.isDefault">
              <div class="info">
                <span class="title_text" v-text="item.itemTitle"></span>
                <span class="vote">
                  <van-icon name="like-o" />{{item.amount}}票
                </span>
              </div>
              <span class="vote_btn" @click.stop="toItemDetail(item)" v-if="!!item.itemLinkUrl&&item.itemLinkUrl.length>0">查看详情</span>
            </div>
          </div>
        </div>
        <!-- 投票进行中、无图 -->
        <div class="vote_list clearfix" v-else-if="detail.status==1 && !detail.imageChoise && detail.isBalloted==false">
          <div class="vote_item" v-for="(item,index) in detail.itemList" :key="index">
            <div :class="{checkbox:true,checked:item.isDefault}" v-if="detail.multipleChoise" @click="onCheckClick(item)">
              <input type="checkbox" :name="'checkboxGorup' + detail.id" :checked="item.isDefault">
              <label>
                <span class="title_text" v-text="item.itemTitle"></span>
              </label>
            </div>
            <div :class="{radio:true,checked:item.isDefault}" v-else @click="onRadioClick(item)">
              <input type="radio" :name="'radioGorup' + detail.id" :checked="item.isDefault">
              <label>
                <span class="title_text" v-text="item.itemTitle"></span>
              </label>
            </div>
          </div>
        </div>
        <!-- 投票未开始、有图 -->
        <div class="vote_list clearfix" v-else-if="detail.status==-1 && detail.imageChoise">
          <div class="vote_item vote_item_img" v-for="(item,index) in detail.itemList" :key="index">
            <div :class="{checkbox:detail.multipleChoise,radio:!detail.multipleChoise}">
              <div class="vote_img_box" @click="toItemDetail(item)">
                <div class="img">
                  <img :src="item.imagePath" alt="" v-if="item.imagePath && item.imagePath.length>0">
                  <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                </div>
              </div>
              <input type="checkbox" :name="'checkboxGorup' + detail.id" disabled v-if="detail.multipleChoise">
              <input type="radio" :name="'radioGorup' + detail.id" disabled v-else>
              <div class="info">
                <span class="title_text" v-text="item.itemTitle"></span>
                <span class="vote">
                  <van-icon name="like-o" />{{item.amount}}票
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 投票未开始、无图 -->
        <div class="vote_list clearfix" v-else-if="detail.status==-1 && !detail.imageChoise">
          <div class="vote_item" v-for="(item,index) in detail.itemList" :key="index">
            <div :class="{checkbox:detail.multipleChoise,radio:!detail.multipleChoise}">
              <input type="checkbox" :name="'checkboxGorup' + detail.id" disabled v-if="detail.multipleChoise">
              <input type="radio" :name="'radioGorup' + detail.id" disabled v-else>
              <label>
                <span class="title_text" v-text="item.itemTitle"></span>
              </label>
            </div>
          </div>
        </div>
        <!-- 投票结束 -->
        <div class="vote_result" v-else>
          <ul>
            <li class="result_item" v-for="(item,index) in detail.itemList" :key="index">
              <div class="result_item_title"><span class="left_title"><span v-text="index+1"></span>.<span v-text="item.itemTitle"></span></span><span class="right_title"><span v-text="getVotePerLabel(item.amount)"></span>，<span v-text="item.amount"></span>票</span></div>
              <div class="result_bar"><span class="bar" :style="{width:getVotePerLabel(item.amount)}"></span></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="operate_box" v-if="detail.status==1 && detail.isBalloted==false">
      <span class="operate_btn" @click="vote" v-if="detail.multipleChoise">提交投票( 已选<span v-text="selectNum"></span>票，剩余<span v-text="remainNum"></span>票)</span>
      <span class="operate_btn" @click="vote" v-else>提交投票</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, addScore } from "@/utils";
import voteApi from "@/api/apis/vote.js";
import commApi from "@/api/apis/common.js";
export default {
  name: "VoteDetail",
  data() {
    return {
      params: {
        contentType: 3,
        id: null,
      },
      detail: null, // 投票详情
      timeStr: null,
      timePicker: null, // 投票结束倒计时
      ids: [],
      selectNum: 0,
      remainNum: 0,
      voteTotal: 0, // 投票总数
      contentCreationTime: "",
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/vote_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 百分比 */
    getVotePerLabel(count) {
      return Math.ceil((count * 10000) / this.voteTotal) / 100 + "%";
    },
    /* 倒计时 */
    getTimePicker(endTime) {
      var timeObj = { day: 0, hour: 0, minite: 0, second: 0 };
      var curTime = new Date().getTime();
      var time = parseInt((endTime - curTime) / 1000);
      if (time > 0) {
        timeObj.second = time % 60;
        let minTime = parseInt(time / 60);
        if (minTime > 0) {
          timeObj.minite = minTime % 60;
          var hourTime = parseInt(minTime / 60);
          if (hourTime > 0) {
            timeObj.hour = hourTime % 24;
            timeObj.day = parseInt(hourTime / 24);
          }
        }
      } else {
        clearInterval(this.timePicker);
      }

      timeObj.hour = timeObj.hour < 10 ? ("0" + timeObj.hour).toString() : timeObj.hour.toString();
      timeObj.minite = timeObj.minite < 10 ? ("0" + timeObj.minite).toString() : timeObj.minite.toString();
      timeObj.second = timeObj.second < 10 ? ("0" + timeObj.second).toString() : timeObj.second.toString();

      return ("<span>" + timeObj.day + "天</span>:<span>" + timeObj.hour + "时</span>:<span>" + timeObj.minite + "分</span>:<span>" + timeObj.second + "秒</span>");
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "投票 - 法治号客户端", _this.detail.title, _this.shareUrl, _this.detail.ballotImagePath);
      }).catch((err) => {

      })
    },
    /* 获取投票详情 */
    getVoteDetail() {
      var _this = this;
      var params = {
        id: _this.params.id,
        memberId: _this.userInfo.id,
        sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
      };

      voteApi
        .ballotDetailed(params)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.data.title;
            _this.detail = res.data.data;
            _this.contentCreationTime = res.data.contentCreationTime;
            _this.wechatShare(); // 微信二次分享
            _this.voteTotal = 0;
            _this.detail.itemList.forEach(function (item, i) {
              if (item.isDefault == 1) {
                _this.ids.push(item.itemId);
              }
              _this.voteTotal += item.amount;
            });
            if (_this.voteTotal == 0) {
              _this.voteTotal = 1;
            }

            _this.selectNum = _this.ids.length;
            _this.remainNum = res.data.data.multiselectNumber - _this.selectNum;

            // 时间倒计时
            if (_this.detail.status == 1) {
              let endTimeStr = _this.detail.endDate + " " + _this.detail.endTime;
              var endTime = new Date(endTimeStr.replace(/-/g, "/")).getTime();
              _this.timePicker = setInterval(function () {
                _this.timeStr = _this.getTimePicker(endTime);
              }, 1000);
              _this.timeStr = _this.getTimePicker(endTime);
            } else {
              _this.timeStr = "<span>00天</span><span>00时</span><span>00分</span><span>00秒</span>";
            }
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "tpdcfbcg", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "参与投票", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.params.contentType, // 非必传，稿件的type
        contentId: this.params.id, // 非必传，稿件的id
        contentName: this.detail.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 跳转详情 */
    toItemDetail(item) {
      if (!!item.itemLinkUrl && item.itemLinkUrl.length > 0) {
        window.open(item.itemLinkUrl, "_self");
      } else {
        this.$toast({
          message: "链接未设置",
          position: "center",
        });
      }
    },
    /* 单选框组，选择操作 */
    onRadioClick(item) {
      if (item.isDefault == 0) {
        item.isDefault = 1;
        this.ids = [item.itemId];
        for (var i = 0; i < this.detail.itemList.length; i++) {
          if (item.itemId != this.detail.itemList[i].itemId) {
            this.detail.itemList[i].isDefault = 0;
          }
        }
      }
    },
    /* 多选框组，选择操作 */
    onCheckClick(item) {
      if (item.isDefault) {
        item.isDefault = 0;
        let index = this.ids.indexOf(item.itemId);
        this.ids.splice(index, 1);
      } else if (this.selectNum >= this.detail.multiselectNumber) {
        item.isDefault = 0;
        this.$toast({
          message: "最多只能选" + this.detail.multiselectNumber + "票",
          position: "center",
        });
        return;
      } else {
        item.isDefault = 1;
        this.ids.push(item.itemId);
      }
      this.selectNum = this.ids.length;
      this.remainNum = this.detail.multiselectNumber - this.selectNum;
    },
    /* 投票 */
    vote() {
      var _this = this;
      if (!!_this.userInfo) {
        var params = {
          ballotId: _this.params.id,
          memberId: _this.userInfo.id,
          itemIds: _this.ids.join(","),
          sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
        };

        voteApi
          .addBallotData(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.getVoteDetail();
              _this.addScore(); // 增加积分
              if (_this.detail.drawRaffleId > 0) {
                _this.$dialog
                  .confirm({
                    message: "投票成功，恭喜您获得一次抽奖机会，现在去抽奖？",
                    cancelButtonText: "放弃",
                    confirmButtonText: "去抽奖",
                  })
                  .then(() => {
                    _this.$router.push({
                      path: "/raffle_detail",
                      query: {
                        contentType: 2,
                        freeFlag: 1,
                        drawRaffleId: _this.detail.drawRaffleId,
                        type: _this.detail.drawRaffleImmediateType
                      },
                    });
                  })
                  .catch(() => { });
              } else {
                _this.$dialog
                  .alert({
                    message: "投票成功！",
                  });
              }
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$router.push("/login");
      }
    },
  },
  created() {
    document.title = "投票";
    let query = this.$route.query;
    if (!!this.userInfo) {
      if (Object.prototype.hasOwnProperty.call(query, "id")) {
        this.params.contentType = Number(query.contentType) || 3;
        this.params.id = Number(query.id);
        this.getVoteDetail(); // 获取投票详情
        loadStat(); // 友盟统计
      } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
        this.params.contentType = Number(query.contentType) || 3;
        this.params.id = Number(query.contentId);
        this.getVoteDetail(); // 获取投票详情
        loadStat(); // 友盟统计
      } else {
        this.$router.replace({
          path: "/error",
        });
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
<style scoped lang="scss">
.vote_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background-color: #f6f6f6;
  overflow-x: hidden;
  overflow-y: auto;
  &.show_operate {
    height: calc(100% - 50px);
  }
  .vote_detail_box {
    width: 100%;
    background: #fff;
    .detail_info {
      position: relative;
      width: 100%;
      padding-bottom: 110px;
      &.pdb2 {
        padding-bottom: 141px;
      }
      img {
        display: block;
        width: 100%;
      }
      .detail_info_box {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        .title {
          height: 30px;
          padding-left: 15px;
          padding-right: 15px;
          line-height: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }
        .vote_detail {
          position: relative;
          width: calc(100% - 30px);
          min-height: 140px;
          padding: 15px;
          background: #fff;
          margin: 10px auto;
          border-radius: 8px;
          box-shadow: 4px 3px 6px #ccc, -4px -3px 6px #ccc;
          .vote_status {
            position: absolute;
            top: 0;
            right: 0;
            padding: 3px 8px;
            color: #fff;
            font-size: 12px;
            color: #fff;
            border-bottom-left-radius: 5px;
            border-top-right-radius: 5px;
            &.ongoing {
              background: #e43732;
            }
            &.over {
              background: rgba(0, 0, 0, 0.5);
            }
            &.not_start {
              background: rgba(235, 190, 11, 0.8);
            }
          }
          .vote_line {
            display: flex;
            padding: 15px 0;
            .vote_item {
              flex: 1;
              &.bd_right {
                border-right: 1px solid #ececec;
              }
              .detail_data {
                line-height: 24px;
                text-align: center;
                color: #1a1a1a;
                font-size: 18px;
                font-weight: bold;
              }
              .detail_label {
                line-height: 24px;
                text-align: center;
                color: #6e6e6e;
                font-size: 14px;
              }
            }
          }
          .vote_time_box {
            .vote_time_label {
              line-height: 32px;
              text-align: center;
              color: #1a1a1a;
              font-size: 18px;
              font-weight: bold;
              &.label_over {
                color: #e93931;
              }
            }
            .vote_time {
              line-height: 30px;
              text-align: center;
              color: #1a1a1a;
              font-weight: bold;
            }
            .vote_time_picker {
              margin-top: 5px;
              color: #eb7a0b;
              margin-bottom: 5px;
              text-align: center;
              /deep/span {
                padding: 3px 8px;
                background-color: #eb7a0b;
                color: #fff;
                border-radius: 5px;
                margin-left: 5px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
    .vote_list_box {
      .vote_title {
        position: relative;
        line-height: 30px;
        padding-left: 15px;
        color: #333;
        font-size: 18px;
        font-weight: bold;
        &::before {
          position: absolute;
          left: 0;
          top: 7px;
          display: block;
          width: 4px;
          height: 16px;
          background-color: #397ef5;
          content: "";
        }
      }
      padding: 0 15px;
      .vote_list {
        padding-top: 10px;
        padding-bottom: 20px;
        .vote_item {
          margin-bottom: 15px;
          .checkbox {
            line-height: 24px;
            padding: 8px 10px;
            border: 1px solid #f2f2f2;
            background-color: #f9f9f9;
            border-radius: 5px;
            overflow: hidden;
            label {
              .title_text {
                margin-left: 5px;
                color: #6e6e6e;
              }
            }
            &.checked {
              border-color: #397ef5;
              background-color: #e8effa;
              label {
                .title_text {
                  margin-left: 5px;
                  color: #397ef5;
                }
              }
            }
          }
          .radio {
            line-height: 24px;
            padding: 8px 10px;
            border: 1px solid #f2f2f2;
            background-color: #f9f9f9;
            border-radius: 5px;
            overflow: hidden;
            label {
              .title_text {
                margin-left: 5px;
                color: #6e6e6e;
              }
            }
            &.checked {
              border-color: #397ef5;
              background-color: #e8effa;
              label {
                .title_text {
                  margin-left: 5px;
                  color: #397ef5;
                }
              }
            }
          }
          &.vote_item_img {
            float: left;
            width: calc(50% - 7.5px);
            &:nth-child(2n + 1) {
              margin-right: 15px;
            }
            .vote_img_box {
              position: relative;
              width: 100%;
              height: 0;
              padding-bottom: 75%;
              background-color: #fff;
              .img {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .checkbox {
              position: relative;
              padding: 0;
              border-radius: 8px;
              input[type="checkbox"] {
                display: none;
              }
              &::after {
                position: absolute;
                right: 0;
                top: -1px;
                display: block;
                width: 30px;
                height: 30px;
                z-index: 2;
                background-image: url(~@/assets/images/icon_unselect.png);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                content: "";
              }
              &.checked {
                background-color: #f9f9f9;
                label {
                  .title_text {
                    color: #6e6e6e;
                  }
                }
                &::after {
                  background-image: url(~@/assets/images/icon_select.png);
                }
              }
            }
            .radio {
              position: relative;
              padding: 0;
              border-radius: 5px;
              input[type="radio"] {
                display: none;
              }
              &::after {
                position: absolute;
                right: 0;
                top: -1px;
                display: block;
                width: 30px;
                height: 30px;
                z-index: 2;
                background-image: url(~@/assets/images/icon_unselect.png);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                content: "";
              }
              &.checked {
                background-color: #f9f9f9;
                label {
                  .title_text {
                    color: #6e6e6e;
                  }
                }
                &::after {
                  background-image: url(~@/assets/images/icon_select.png);
                }
              }
            }
            .info {
              padding: 20px 12px 10px;
              line-height: 21px;
              .title_text {
                color: #333;
                font-size: 14px;
              }
              .vote {
                float: right;
                color: #397ef5;
                font-size: 14px;
              }
            }
          }
          .vote_btn {
            position: absolute;
            bottom: 38px;
            left: 20%;
            z-index: 2;
            display: block;
            width: 60%;
            height: 32px;
            line-height: 32px;
            background: -webkit-linear-gradient(#41adfe, #037efd);
            background: -o-linear-gradient(#41adfe, #037efd);
            background: -moz-linear-gradient(#41adfe, #037efd);
            background: linear-gradient(#41adfe, #037efd);
            text-align: center;
            color: #fff;
            font-size: 14px;
            border-radius: 5px;
          }
        }
      }
      .vote_result {
        padding-top: 10px;
        padding-bottom: 20px;
        .result_item {
          padding-bottom: 5px;
          .result_item_title {
            height: 24px;
            line-height: 24px;
            margin-bottom: 5px;
            .left_title {
              color: #3f5191;
            }
            .right_title {
              float: right;
              color: #3f5191;
            }
          }
          .result_bar {
            width: 100%;
            height: 12px;
            border-radius: 6px;
            background-color: #f0f0f0;
            overflow: hidden;
            margin-bottom: 5px;
            .bar {
              display: block;
              height: 100%;
              width: 0;
              background: -o-linear-gradient(
                left,
                #7bc7fb,
                #37d3ff
              ); /*Opera11*/
              background: -moz-linear-gradient(
                left,
                #7bc7fb,
                #37d3ff
              ); /*Mozilla*/
              background: -webkit-gradient(
                linear,
                0 50%,
                100% 50%,
                from(#7bc7fb),
                to(#37d3ff)
              ); /*Old gradient for webkit*/
              background: -webkit-linear-gradient(
                left,
                #7bc7fb,
                #37d3ff
              ); /*new gradient for Webkit*/
              border-radius: 6px;
              -webkit-transition: all 0.3s linear;
              -webkit-transition: all 0.3s;
              transition: all 0.3s;
            }
          }
        }
      }
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 50px;
    padding: 5px 5px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .operate_btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      background-color: #397ef5;
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>